export const state = {
    topGainers:{},
    faqslist:{},
    hoopsData : [],
    newsData : {},
    cryptoNewsData : {}
}